

































import Vue from 'vue';
import { DemoClient, FailedDemo } from '@/assets/src/clients/demo_client';
import { SearchParameter } from '@/assets/src/search_parameter';
import { toNiceDate } from '@/assets/src/utils/date';
import ROUTE_NAMES from '@/assets/src/routes';

export default Vue.extend({
  name: 'ListFailedDemos',

  methods: {
    toNiceDate,

    async listDemos() {
      this.demos = await this.demoClient.listFailedParsings([]);
    },
  },

  created() {
    this.listDemos();
  },

  data() {
    return {
      demos: [] as FailedDemo[],
      demoClient: new DemoClient(),
    };
  },

  routeNames: ROUTE_NAMES,
});
